// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dBZd","rightAdornment":"Header_rightAdornment__29DWt"};